export default __webpack_public_path__ + "static/media/logo.857ab95d.png";